const e = "";
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/com-components/op-region-select/RegionSelect.vue2.js
// module id = 825
// module chunks = 41